import { Delete } from "lucide-react";

export default function PinPad({ value, onChange, onSubmit, maxLength = 6 }) {
  const press = (n) => {
    if (value.length < maxLength) onChange(value + n);
  };
  const back = () => onChange(value.slice(0, -1));

  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

  return (
    <div className="w-full">
      <div className="grid grid-cols-3 gap-2 sm:gap-3 w-full">
        {keys.map((k) => (
          <button
            key={k}
            data-testid={`pin-key-${k}`}
            type="button"
            onClick={() => press(k)}
            className="num-tile h-16 sm:h-20 border-2 border-neutral-900 bg-white hover:bg-neutral-50 font-mono text-3xl font-bold text-neutral-900 transition-all"
          >
            {k}
          </button>
        ))}
        <button
          data-testid="pin-key-clear"
          type="button"
          onClick={() => onChange("")}
          className="num-tile h-16 sm:h-20 border-2 border-neutral-900 bg-neutral-100 hover:bg-neutral-200 font-display text-sm font-bold uppercase tracking-widest transition-all"
        >
          Limpar
        </button>
        <button
          data-testid="pin-key-0"
          type="button"
          onClick={() => press("0")}
          className="num-tile h-16 sm:h-20 border-2 border-neutral-900 bg-white hover:bg-neutral-50 font-mono text-3xl font-bold text-neutral-900 transition-all"
        >
          0
        </button>
        <button
          data-testid="pin-key-back"
          type="button"
          onClick={back}
          className="num-tile h-16 sm:h-20 border-2 border-neutral-900 bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-all"
        >
          <Delete className="w-6 h-6" strokeWidth={2.5} />
        </button>
      </div>
      <button
        data-testid="pin-submit-btn"
        type="button"
        onClick={onSubmit}
        disabled={value.length < 4}
        className="mt-4 w-full h-14 bg-neutral-950 hover:bg-neutral-800 text-white font-display font-bold text-lg uppercase tracking-widest transition-all disabled:opacity-40 disabled:cursor-not-allowed cta-brutal"
      >
        Entrar
      </button>
    </div>
  );
}
